(function () {
    'use strict';

    angular
        .module('adminODDControllers', []);
})();
